



















































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import AMSTable from '@/components/AMSTable.vue';
import utils from '@/utils/utils';
import AMSBreadcrumb from '@/components/AMSBreadcrumb.vue';
@Component({
  components: {
    'ams-table': AMSTable,
    'ams-breadcrumb': AMSBreadcrumb
  }
})
export default class ShipmentsManagementList extends Vue {
  /**面包屑 */
  breadItems = [
    {
      text: '订单管理',
      disabled: false,
      href: 'finnancialManagement'
    },
    {
      text: '配货/出库/发货',
      disabled: true,
      href: '/orderManage/shipmentList'
    }
  ];
  tabs: string[] = ['订单详情', '配货/出货/发货', '扣款记录'];
  tab: any = null;

  headers: object = {
    pickHeaders: [
      { text: '序号', align: 'center', sortable: false, value: 'author', width: '200px' },
      { text: '商品', align: 'center', sortable: false, value: 'author', width: '200px' },
      { text: '订购数', align: 'center', sortable: false, value: 'author', width: '200px' },
      { text: '已配货数', align: 'center', sortable: false, value: 'author', width: '200px' },
      { text: '待配货数', align: 'center', sortable: false, value: 'author', width: '200px' },
      { text: '实际库存', align: 'center', sortable: false, value: 'author', width: '200px' },
      { text: '配货数量', align: 'center', sortable: false, value: 'author', width: '200px', isInputNumber: true }
    ],
    pickShow: true,
    deliveryHeaders: [
      { text: '序号', align: 'center', sortable: false, value: 'author', width: '200px' },
      { text: '商品名称', align: 'center', sortable: false, value: 'author', width: '200px' },
      { text: '容量', align: 'center', sortable: false, value: 'author', width: '200px' },
      { text: '出库数', align: 'center', sortable: false, value: 'author', width: '200px' }
    ],
    deliveryShow: true,
    shipHeaders: [
      { text: '序号', align: 'center', sortable: false, value: 'author', width: '200px' },
      { text: '商品名称', align: 'center', sortable: false, value: 'author', width: '200px' },
      { text: '容量', align: 'center', sortable: false, value: 'author', width: '200px' },
      { text: '发货数', align: 'center', sortable: false, value: 'author', width: '200px' }
    ],
    shipShow: true,
    chargeHeaders: [
      { text: '序号', align: 'center', sortable: false, value: 'author', width: '200px' },
      { text: '商品名称', align: 'center', sortable: false, value: 'author', width: '200px' },
      { text: '容量', align: 'center', sortable: false, value: 'author', width: '200px' },
      { text: '订购量', align: 'center', sortable: false, value: 'author', width: '200px' },
      { text: '出货量', align: 'center', sortable: false, value: 'author', width: '200px' },
      { text: '单价', align: 'center', sortable: false, value: 'author', width: '200px' },
      { text: '扣款金额', align: 'center', sortable: false, value: 'author', width: '200px' }
    ],
    chargeShow: true
  };
  showIcon: string = 'unfold_less';
  hideIcon: string = 'unfold_more';

  data: object = {
    /**配货清单 */
    pickTotalCount: 0,
    picks: [],
    /**出库清单 */
    deliveryTotalCount: 0,
    deliverys: [],
    /**发货清单 */
    shipTotalCount: 0,
    ships: [],
    /**扣款记录 */
    chargeTotalCount: 1,
    charges: [
      {
        a: '1',
        b: '这是个商品',
        c: '3ml',
        d: '4',
        e: '5',
        f: '6',
        g: '7'
      }
    ]
  };
  printDialog: boolean = false;

  /**点击了打印按钮 */
  onPrintClick(item: any, index: number) {
    this.printDialog = true;
  }

  /**点击了弹窗里面的打印 */
  onConfimPrintClick() {
    console.log((this.$refs.printDiv as Element).innerHTML);
    let content: string = this.generateHtml();
    let iframe = document.createElement('iframe');
    iframe.id = 'printIframe';
    // iframe.setAttribute('style', 'position:absolute;width:0;height:0;top:-10px;left:-10px;');
    let f = document.body.appendChild(iframe);
    let w = (f.contentWindow || f.contentDocument) as Window;
    let doc = f.contentDocument || f.contentWindow!.document;
    doc.open();
    doc.write(content);
    doc.close();
    iframe.onload = function() {
      w.focus();
      try {
        if (!w.document.execCommand('print', false)) {
          w.print();
        }
      } catch (e) {
        w.print();
      }
      w.close();
      document.body.removeChild(iframe);
    };
  }
  getPermission(name: string) {
    return utils.isPermission(name);
  }
  generateHtml(): string {
    let style = this.getStyle();
    let content: string = (this.$refs.printDiv as Element).innerHTML;
    let html = `<head>${style}</head><body>${content}</body>`;
    return html;
  }

  getStyle(): string {
    var str = '',
      styles = document.querySelectorAll('style,link');
    for (var i = 0; i < styles.length; i++) {
      str += styles[i].outerHTML;
    }
    return str;
  }

  /**点击了打印关闭弹窗 */
  onCloseClick() {
    this.printDialog = false;
  }
}
